/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Item_Stats_Lastknownprice2Inputs */

const he_item_stats_lastknownprice2 = /** @type {(inputs: Item_Stats_Lastknownprice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחיר אחרון`)
};

const en_item_stats_lastknownprice2 = /** @type {(inputs: Item_Stats_Lastknownprice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last known price`)
};

/**
* | output |
* | --- |
* | "Last known price" |
*
* @param {Item_Stats_Lastknownprice2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const item_stats_lastknownprice2 = /** @type {((inputs?: Item_Stats_Lastknownprice2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Stats_Lastknownprice2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_item_stats_lastknownprice2(inputs)
	return en_item_stats_lastknownprice2(inputs)
});
export { item_stats_lastknownprice2 as "item_stats_lastKnownPrice" }